var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShieldAlt = function SvgShieldAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.212 2.722 12 0 3.788 2.722A2.6 2.6 0 0 0 2 5.195v6.664c0 6.609 7.159 10.703 9.354 11.8l.626.313.65-.262C15.447 22.577 22 19.165 22 11.967V5.195a2.605 2.605 0 0 0-1.788-2.473M3 11.858V5.194c0-.692.443-1.305 1.103-1.523L11.5 1.219v21.39C9.161 21.392 3 17.636 3 11.859Zm18 .108c0 6.399-5.76 9.568-8.5 10.713V1.219l7.397 2.452A1.605 1.605 0 0 1 21 5.194z"
  })));
};
export { SvgShieldAlt as ReactComponent };
export default __webpack_public_path__ + "assets/images/shield-alt.svg";